import * as React from "react";
import {cx}                from "emotion";

import "./step-1-map.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {equalDeep}      from "@Common/utils/objects";

import {GlobalResizeState} from "../../../../../../browser/global-resize-state";
import {isDevQuan}         from "../../../../../../debug/is-dev-quan";
import {ConfirmCancel}     from "../../common/confirm-cancel";
import {Header}            from "../../common/header/header";

import {MapSection}    from "./map-section/map-section";
import {RadiusSideBar} from "./radius-side-bar/radius-side-bar";

export const Step1Map = ({next}) => cs(
    consumeContext("apis"),
    ["viewSize", (_, next) => GlobalResizeState({
        translate: ({width, height}) => height < 900 ? {
            size: "md",
            showFeedback: width >= 480 && window.document.getElementById('hj-survey-toggle-1'),
        } : {
            size: "lg",
            showFeedback: width >= 480 && window.document.getElementById('hj-survey-toggle-1'),
        },
        next,
    })],
    ["searchedForm", (_, next) => UseState({
        // ...isDevQuan() && {
        //     initValue: {
        //         address: "111 aaa",
        //     },
        // },
        next,
    })],
    ["searchError", (_, next) => UseState({next})],
    ["streets", (_, next) => UseState({
        // ...isDevQuan() && {
        //     initValue: {
        //         streets: {},
        //     },
        // },
        next,
    })],
    ["addresses", (_, next) => UseState({next})],
    ["loading", (_, next) => UseState({initValue: {loading: false}, next})],
    ["view", (_, next) => UseState({initValue: "search", next})],
    ["search", ({searchedForm, searchError, streets, view, apis}, next) => next(async ({data}) => {
        searchError.onChange(null);
        try {
            if (!equalDeep(data.value, searchedForm.value)) {
                searchedForm.onChange(data.value);
                streets.onChange(null);

                const result = await apis.next.mailing.searchRadius(data.value);

                if (result?.alternateAddress != null) {
                    data.onChange({
                        ...data.value,
                        address: result.alternateAddress
                    });
                }
                searchedForm.onChange({
                    ...data.value,
                    address: result?.alternateAddress ?? data.value.address,
                });
                streets.onChange(result);
            }
            view.onChange("addresses");
        } catch (e) {
            if (e.type === "notFound") {
                searchError.onChange({
                    type: "notFound",

                    street: data.value.address,
                    zipCode: data.value.zip,
                });
            } else if (e.type === "alternateStreets") {
                searchError.onChange({
                    type: "alternateStreets",
                    street: data.value.address,
                    zipCode: data.value.zip,
                    alternateStreets: e.alternateStreets,
                });
            } else {
                alert("Unknown error");
            }
        }
    })],
    ["mapSection", ({viewSize, view, addresses, loading}, next) => MapSection({
        addresses,
        loading,
        viewSize: viewSize.size,
        view,
        next
    })],
    ["radiusSideBar", ({viewSize, view, streets, addresses, loading, searchedForm, search, searchError, mapSection}, next) => RadiusSideBar({
        streets,
        addresses,
        loading,
        view, 
        viewSize: viewSize.size, 
        searchedForm: searchedForm.value, 
        onSearch: search, 
        searchError,
        renderErrorNoti: mapSection.renderErrorNoti, 
        next
    })],
    ["confirmCancel", (_, next) => ConfirmCancel({next})],
    ({radiusSideBar, mapSection, searchedForm, viewSize, streets, confirmCancel}) => next({
        onPassiveClose: streets.value && confirmCancel,
        getDefaultListName: () => searchedForm.value.address,
        createRequestData: async () => ({
            searchForm: searchedForm.value,
            searchResult: {
                ...await radiusSideBar.createRequestData(),
            },
        }),
        render: ({onCancel, cancelLabel, onNext}) => cs(
            ["nextAction", ({}, next) => next(radiusSideBar.getNextAction({onNext, loadErrorHighlight: mapSection.highlightErrors}))],
            ({nextAction}) => (
                <div className="step-1-map-u8t">
                    {Header({
                        icon: require("../../../../mailing-icons/listtype-radius.png"),
                        title: "Build Radius List",
                        subTitle: "Build a list targeting prospects surrounding a specific point.",
                    })}

                    <div className="content">
                        {radiusSideBar.render()}
                        {mapSection.render()}
                    </div>

                    <div className="footer">
                        {viewSize.showFeedback && <a {...{
                            className: "feedback",
                            onClick: () => {
                                // @ts-ignore for warning against missing click function
                                window.document.getElementById('hj-survey-toggle-1')?.click();
                            },
                            "xd-qa-type": "link",
                            "xd-qa-name": "Build Radius List Feedback"
                        }}>
                            Have feedback?
                        </a>}
                        <button {...{
                            className: "cancel",
                            onClick: async () => {
                                if (streets.value) {
                                    if (await confirmCancel()) {
                                        onCancel();
                                    }
                                } else {
                                    onCancel();
                                }
                            },
                            "xd-qa-type": "button",
                            "xd-qa-name": "Build Radius List " + cancelLabel,
                        }}>
                            {cancelLabel}
                        </button>
                        {nextAction && (
                            <button {...{
                                className: cx("next", {disabled: nextAction.disabled}),
                                onClick: nextAction.action,
                                "xd-qa-type": "button",
                                "xd-qa-name": "Build Radius List Next",
                            }}>
                                Next
                            </button>
                        )}
                    </div>
                </div>
            ),
        ),
    })
);